<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <div>
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="卡组名称：" prop="name">
              <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入卡组名称"></el-input>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="bg-theme" @click="cardGroupCreateOpenBtn">创建卡组</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardName"
            label="礼品卡名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardDeckName"
            label="卡组名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="cardNumber"
            label="生成数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toDetailBtn(scope.row.id)" type="text" size="small">查看详情</el-button>
              <el-button @click="operaBtn(scope.row.id,1)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">全部激活</el-button>
              <el-button @click="operaBtn(scope.row.id,2)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">全部作废</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 生成卡组弹窗 -->
    <el-dialog
      title="生成卡组"
      :visible.sync="cardGroupCreateShow"
      width="960px">
      <el-form :model="cardGroupCreateForm" :rules="rules" label-width="140px">
        <el-form-item label="卡组名称：">
          <el-input style="width: 420px;" v-model="cardGroupCreateForm.name" placeholder="请输入卡组名称"></el-input>
        </el-form-item>
        <el-form-item label="生成数量：">
          <el-input style="width: 420px;" v-model="cardGroupCreateForm.num" placeholder="请输入生成数量"></el-input>
          <div class="mt-warm-txt"><span>一次最大可生成1000条，生成中请勿关闭页面等待生成成功</span></div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="cardGroupCreateSaveBtn">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryGiftCardDeckPageList, saveGiftCardDeck, activeCardMine,cancelCardMine  } from '@/api/giftCard'
export default {
  name: 'CardGroup',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 生成卡组弹窗
      cardGroupCreateShow:false,
      cardGroupCreateForm:{
        name:'',
        num:''
      },
      rules: {
        name: [
          { required: true, message: '请输入卡组名称', trigger: 'blur' }
        ],
        num: [
          { required: true, message: '请输入生成数量', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 生成卡组弹窗-打开操作
    cardGroupCreateOpenBtn(){
      this.cardGroupCreateShow = true;
    },
    // 生成卡组弹窗-保存操作
    cardGroupCreateSaveBtn(){
      this.cardGroupCreateShow = false;
      var cardNumber = this.cardGroupCreateForm.num;
      var cardDeckName = this.cardGroupCreateForm.name;
      var dataId = this.dataId;
      if(cardDeckName == ''){
        this.$message.error('请输入卡组名称')
        return false
      }
      if(cardNumber == ''){
        this.$message.error('请输入生成数量')
        return false
      }
      var that = this;
      saveGiftCardDeck({ cardId: dataId, cardNumber: cardNumber, cardDeckName: cardDeckName}).then((res) => {
        if (res.errorCode === '0000') {
          that.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.cardGroupCreateForm.num = '';
              that.cardGroupCreateForm.name = '';
              that.cardGroupCreateShow = false;
              that.getInfoList();
            }
          })
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
    },
    // type 1全部激活 2全部作废
    operaBtn(infoId, type){
      var typeTxt = type == 1 ? '激活' : '作废';
      var that = this;
      this.$confirm('确认全部'+typeTxt+'吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        if(type == 1){
          // 全部激活
          activeCardMine({ id: infoId }).then((res) => {
            that.backDataFun(res)
          })
        }else{
          // 全部作废
          cancelCardMine({ id: infoId }).then((res) => {
            that.backDataFun(res)
          })
        }
      }).catch(() => {})
    },
    backDataFun(res){
      var that = this
      that.fullscreenLoading = false
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.getInfoList();
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let dataId = that.dataId
      let page = that.currentPage
      queryGiftCardDeckPageList({ cardId: dataId, cardDeckName: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 跳转查看卡组页面
    toDetailBtn(infoId){
      this.$router.push({path: '/watch_card_group', query: {dataId: infoId}})
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/CardGroup.vue